"use strict";

import gsap from "gsap";
import { CustomEase } from "gsap/all";

const projAnimation = function (a, b) {
	gsap.registerPlugin(CustomEase);

	const i = a + 1,
		o = b + 1;

	const projIn = document.querySelector(`.project:nth-child(${i})`),
		projOut = document.querySelector(`.project:nth-child(${o})`),
		imgIn = projIn.querySelector(".display-image"),
		logoIn = projIn.querySelector(".client-logo"),
		textIn = projIn.querySelectorAll(".project-content > *"),
		imgOut = projOut.querySelector(".display-image"),
		logoOut = projOut.querySelector(".client-logo"),
		textOut = projOut.querySelectorAll(".project-content > *");

	const breakPoint = gsap.matchMedia();
	const tl = gsap.timeline({
		defaults: {
			duration: 1,
			ease: CustomEase.create("custom", "M0,0 C0.105,1 0.617,0.985 1,1 "),
		},
	});

	if (i > o) {
		// current project is greater than previous project
		breakPoint.add("(max-width: 1024px)", () => {
			tl.to(imgOut, { y: "-50%", duration: 1.3 })
				.to(imgOut, { opacity: 0, duration: 0.3, ease: "none" }, "<")
				.to(logoOut, { y: "-100%", duration: 0.01 }, 0)
				.to(logoOut, { opacity: 0, duration: 0.3, ease: "none" }, "<")
				.to(textOut[0], { y: "-400%" }, "<0.05")
				.to(textOut[0], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[1], { y: "-200%" }, "<0.05")
				.to(textOut[1], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[2], { y: "-160%" }, "<0.05")
				.to(textOut[2], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[3], { y: "-300%" }, "<0.05")
				.to(textOut[3], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(projOut, { autoAlpha: 0, duration: 0.2 }, "<")
				.to(projIn, { autoAlpha: 1, duration: 0.5 }, "<0.01")
				.to(imgIn, { y: 0, duration: 1.5 }, "<0.1")
				.to(imgIn, { opacity: 1, duration: 1, ease: "none" }, "<")
				.to(logoIn, { y: 0, duration: 0.01 }, 0)
				.to(logoIn, { opacity: 1, duration: 1.5, ease: "none" }, "<0.1")
				.to(textIn, { y: 0, duration: 1.5, stagger: 0.2 }, "<0.1")
				.to(textIn, { opacity: 1, duration: 0.3, ease: "none", stagger: 0.2 }, "<");
		});

		breakPoint.add("(min-width: 1025px)", () => {
			tl.to(imgOut, { y: "-50%", duration: 1.3 })
				.to(imgOut, { opacity: 0, duration: 0.3, ease: "none" }, "<")
				.to(textOut[0], { y: "-400%" }, 0)
				.to(textOut[0], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[1], { y: "-200%" }, "<0.05")
				.to(textOut[1], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[2], { y: "-160%" }, "<0.05")
				.to(textOut[2], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[3], { y: "-300%" }, "<0.05")
				.to(textOut[3], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(logoOut, { opacity: 0, duration: 0.3, ease: "none" }, "<-=0.2")
				.to(logoOut, { y: "-100%", duration: 0.01 }, ">-=0.1")
				.to(projOut, { autoAlpha: 0, duration: 0.2 }, "<")
				.to(projIn, { autoAlpha: 1, duration: 0.5 }, 0.2)
				.to(imgIn, { y: 0, duration: 1.5 }, "<0.1")
				.to(imgIn, { opacity: 1, duration: 0.4, ease: "none" }, "<")
				.to(textIn, { y: 0, duration: 1.5, stagger: 0.2 }, 0)
				.to(textIn, { opacity: 1, duration: 0.3, ease: "none", stagger: 0.2 }, "<")
				.to(logoIn, { y: 0, duration: 0.01 }, 0)
				.to(logoIn, { opacity: 1, duration: 1.5, ease: "none" }, "<0.1");
		});
	} else {
		// Previous project is greater than current project
		breakPoint.add("(max-width: 1024px)", () => {
			tl.to(textOut[3], { y: "300%" })
				.to(textOut[3], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[2], { y: "160%" }, "<0.05")
				.to(textOut[2], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[1], { y: "200%" }, "<0.05")
				.to(textOut[1], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[0], { y: "400%" }, "<0.05")
				.to(textOut[0], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(imgOut, { y: "50%", duration: 1.3 }, "<")
				.to(imgOut, { opacity: 0, duration: 0.3, ease: "none" }, "<")
				.to(logoOut, { opacity: 0, duration: 0.3, ease: "none" }, "<0.05")
				.to(logoOut, { y: "100%", duration: 0.01 }, "<")
				.to(projOut, { autoAlpha: 0, duration: 0.2 }, "<")
				.to(projIn, { autoAlpha: 1, duration: 0.5 }, "<0.01")
				.to(textIn, { stagger: -0.2, y: 0, duration: 1.5 }, "<0.1")
				.to(textIn, { stagger: -0.2, opacity: 1, duration: 0.3, ease: "none" }, "<")
				.to(imgIn, { y: 0, duration: 1.8 }, "<0.2")
				.to(imgIn, { opacity: 1, duration: 0.8, ease: "none" }, "<")
				.to(logoIn, { y: 0, duration: 0.01 }, "<")
				.to(logoIn, { opacity: 1, duration: 1.5, ease: "none" }, "<0.1");
		});

		breakPoint.add("(min-width: 1025px)", () => {
			tl.to(imgOut, { y: "50%", duration: 1.3 })
				.to(imgOut, { opacity: 0, duration: 0.3, ease: "none" }, "<")
				.to(textOut[3], { y: "300%" }, 0)
				.to(textOut[3], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[2], { y: "160%" }, "<0.05")
				.to(textOut[2], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[1], { y: "200%" }, "<0.05")
				.to(textOut[1], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(textOut[0], { y: "400%" }, "<0.05")
				.to(textOut[0], { opacity: 0, duration: 0.2, ease: "none" }, "<")
				.to(logoOut, { opacity: 0, duration: 0.3, ease: "none" }, "<-=0.2")
				.to(logoOut, { y: "100%", duration: 0.01 }, ">-=0.1")
				.to(projOut, { autoAlpha: 0, duration: 0.2 }, "<")
				.to(projIn, { autoAlpha: 1, duration: 0.5 }, 0.2)
				.to(imgIn, { y: 0, duration: 1.8 }, "<0.1")
				.to(imgIn, { opacity: 1, duration: 0.8, ease: "none" }, "<")
				.to(textIn, { stagger: -0.2, y: 0 }, 0)
				.to(textIn, { stagger: -0.2, opacity: 1, duration: 0.1, ease: "none" }, "<")
				.to(logoIn, { y: 0, duration: 0.01 }, 0)
				.to(logoIn, { opacity: 1, duration: 1.5, ease: "none" }, "<0.1");
		});
	}

	return tl;
};

export default projAnimation;
